import { gql } from "@apollo/client";

// Section for Create Attendance
export const CREATE_AUTHORIZED_SIGNATURE = gql`
  mutation CreateAuthorizedSignature($input: createAuthorizedSignature) {
    createAuthorizedSignature(input: $input) {
      Id
    }
  }
`;

export const UPDATE_AUTHORIZED_SIGNATURE = gql`
  mutation UpdateAuthorizedSignature($input: updateAuthorizedSignature) {
    updateAuthorizedSignature(input: $input)
  }
`;

export const DELETE_AUTHORIZED_SIGNATURE = gql`
  mutation DeleteAuthorizedSignature($Id: Int) {
    deleteAuthorizedSignature(Id: $Id)
  }
`;

export const GET_AUTHORIZED_SIGNATURE_BY_ID = gql`
  query AuthorizedSignaturesById($Id: Int) {
    authorizedSignaturesById(Id: $Id) {
      Id
      name
      attachment
    }
  }
`;

export const GET_AUTHORIZED_SIGNATURES_BY_ORGID = gql`
  query AuthorizedSignaturesByOrg {
    authorizedSignaturesByOrg {
      Id
      attachment
      name
    }
  }
`;
